import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';

const CoordinateColorSelector = ({ coordinateColor, setCoordinateColor }) => {
  const { t } = useTranslation();

  return (
    <section className="settings-section">
      <h3>🔢 {t('settings.coordinateColor')}</h3>
      <p className="section-description">{t('settings.coordinateDescription', 'Customize the color of rank numbers (1-8) and file letters (a-h)')}</p>
      
      <div className="color-pickers">
        <div className="color-picker-item">
          <label>{t('settings.coordinateColor')}:</label>
          <input
            type="color"
            value={coordinateColor}
            onChange={(e) => setCoordinateColor(e.target.value)}
          />
          <span className="color-value">{coordinateColor}</span>
        </div>
      </div>
    </section>
  );
};

export default CoordinateColorSelector;
